<block-ui>
    <ng-content></ng-content>
</block-ui>
